<div [ngClass]="{ 'with-container': padding }">
  <ng-content />
</div>
